module.exports = __webpack_public_path__ + "img/circulo.248bf675.gif";